import { getSiteContext, isSameOrigin, addSiteContextToUrl } from '@scripts/utils/site-context-utils.js';

function init() {
    // Determine site context once
    const siteContext = getSiteContext();

    // Axios
    // This will most likely do nothing unless at some point axios gets attached to the window by
    // a page script
    // See: vite.config.mjs and the axios wrapper for how this is handled for modules
    if (window.axios) {
        axios.interceptors.request.use(config => {
            if (siteContext && isSameOrigin(config.url)) {
                config.url = addSiteContextToUrl(config.url, siteContext);
            }
            return config;
        });
    }

    // jQuery
    if (window.jQuery) {
        $.ajaxPrefilter((options) => {
            if (siteContext && isSameOrigin(options.url)) {
                options.url = addSiteContextToUrl(options.url, siteContext);
            }
        });
    }

    // Fetch
    const originalFetch = window.fetch;
    window.fetch = function (url, options = {}) {
        if (siteContext && isSameOrigin(url)) {
            url = addSiteContextToUrl(url, siteContext);
        }
        return originalFetch(url, options);
    };

}

export { init }